import { isStealth } from "./commonUtils";
import { getNextDayOfWeek } from "./dateTimeUtils";

export const existingUserFields: { [key: string]: ViewField } = [
  { label: "Email", key: "identity.email", order: 1 },
  { label: "Secondary Email", key: "identity.secondary_email", order: 2 },
  { label: "Employee ID", key: "employee_id", order: 3 },
  {
    label: "Gender",
    key: "gender",
    order: 4,
  },
  {
    label: "Team",
    key: "attached_group.name",
    order: 5,
  },
  {
    label: "Team Role",
    key: "attached_group_role",
    order: 6,
  },
  {
    label: "Shift",
    key: "shift.name",
    order: 8,
  },
  {
    label: "Designation",
    key: "designation.name",
    order: 7,
  },
  {
    label: "Phone Number",
    key: "phone_number",
    order: 10,
  },

  {
    label: "Date of Joining",
    key: "date_of_joining",
    order: 11,
  },
  {
    label: "Date of Birth",
    key: "date_of_birth",
    order: 12,
  },
  {
    label: "Created Date",
    key: "created_date",
    order: 13,
  },
].reduce((acc, field) => ({ ...acc, [field.key]: field }), {});

export const filterLabels = {
  ...Object.values(existingUserFields).reduce(
    (acc, field) => ({ ...acc, [field.key]: field.label }),
    {}
  ),
  "identity.first_name": "First Name",
  "identity.last_name": "Last Name",
  "shift.id": "Shift",
  "designation.id": "Designation",
  user_type: "User Type",
};

const customIntegerFilterUnit: FilterConfigUnit = {
  type: "OPTION",
  options: {
    is_set: {
      type: "VALUE",
      complete: true,
      filterKey: "isNotNull",
    },
    is_not_set: {
      type: "VALUE",
      complete: true,
      filterKey: "isNull",
    },
    is_greater_than: {
      type: "INTEGER_INPUT",
      complete: true,
      filterKey: "greaterThanOrEqualTo",
    },
    is_less_than: {
      type: "INTEGER_INPUT",
      complete: true,
      filterKey: "lessThanOrEqualTo",
    },
    is_equal_to: {
      type: "INTEGER_INPUT",
      complete: true,
      filterKey: "equals",
    },
  },
};

const customStringFilterUnit: FilterConfigUnit = {
  type: "OPTION",
  options: {
    is: {
      type: "STRING_INPUT",
      complete: true,
      filterKey: "equals",
    },
    is_set: {
      type: "VALUE",
      complete: true,
      filterKey: "isNotNull",
    },
    is_not_set: {
      type: "VALUE",
      complete: true,
      filterKey: "isNull",
    },
    contains: {
      type: "STRING_INPUT",
      complete: true,
      filterKey: "ilike",
    },
  },
};

const customBooleanFilterUnit: FilterConfigUnit = {
  type: "OPTION",
  options: {
    is_True: {
      type: "VALUE",
      complete: true,
      filterKey: "equals",
      value: true,
    },
    is_False: {
      type: "VALUE",
      complete: true,
      filterKey: "equals",
      value: false,
    },
    is_not_set: {
      type: "VALUE",
      complete: true,
      filterKey: "isNull",
    },
  },
};

export const filtersConfig: { [key: string]: FilterConfigUnit } = {
  "identity.first_name": {
    type: "OPTION",
    options: {
      is: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "equals",
      },
      contains: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "ilike",
      },
    },
  },
  "identity.last_name": {
    type: "OPTION",
    options: {
      is: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "equals",
      },
      contains: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "ilike",
      },
    },
  },
  "identity.email": {
    type: "OPTION",
    options: {
      is: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "equals",
      },
      contains: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "ilike",
      },
    },
  },
  "identity.secondary_email": {
    type: "OPTION",
    options: {
      is: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "equals",
      },
      is_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNotNull",
      },
      is_not_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNull",
      },
      contains: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "ilike",
      },
    },
  },
  employee_id: {
    type: "OPTION",
    options: {
      is: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "equals",
      },
      is_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNotNull",
      },
      is_not_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNull",
      },
      contains: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "ilike",
      },
    },
  },
  user_type: {
    type: "OPTION",
    options: {
      is_Stealth: {
        type: "VALUE",
        complete: true,
        filterKey: "equals",
        value: "STEALTH",
      },
      is_Standard: {
        type: "VALUE",
        complete: true,
        filterKey: "equals",
        value: "STANDARD",
      },
    },
  },
  "attached_group.name": {
    type: "OPTION",
    options: {
      is: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "equals",
      },
      contains: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "ilike",
      },
    },
  },
  attached_group_role: {
    type: "OPTION",
    options: {
      is: {
        type: "MULTI_SELECT_TEAM_ROLE_TYPE",
        complete: true,
        filterKey: "contains",
      },
    },
  },
  gender: {
    type: "OPTION",
    options: {
      is: {
        type: "MULTI_SELECT_GENDER_TYPE",
        complete: true,
        filterKey: "contains",
      },
    },
  },
  "shift.id": {
    type: "OPTION",
    options: {
      is: {
        type: "MULTI_SELECT_SHIFT_TYPE",
        complete: true,
        filterKey: "contains",
        hints: { "contains.shift.id": "uuid" },
      },
      is_not: {
        type: "MULTI_SELECT_SHIFT_TYPE",
        complete: true,
        filterKey: "notContains",
        hints: { "notContains.shift.id": "uuid" },
      },
      is_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNotNull",
      },
      is_not_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNull",
      },
    },
  },
  "designation.id": {
    type: "OPTION",
    options: {
      is: {
        type: "MULTI_SELECT_DESIGNATION_TYPE",
        complete: true,
        filterKey: "contains",
        hints: { "contains.designation.id": "uuid" },
      },
      is_not: {
        type: "MULTI_SELECT_DESIGNATION_TYPE",
        complete: true,
        filterKey: "notContains",
        hints: { "notContains.designation.id": "uuid" },
      },
      is_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNotNull",
      },
      is_not_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNull",
      },
    },
  },
  phone_number: {
    type: "OPTION",
    options: {
      is: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "equals",
      },
      is_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNotNull",
      },
      is_not_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNull",
      },
      contains: {
        type: "STRING_INPUT",
        complete: true,
        filterKey: "ilike",
      },
    },
  },
  date_of_joining: {
    type: "OPTION",
    options: {
      is: {
        type: "OPTION",
        options: {
          This_week: {
            type: "VALUE",
            complete: true,
            filterKey: ["lessThanOrEqualTo", "greaterThanOrEqualTo"],
            value: [
              getNextDayOfWeek(new Date(), 6),
              (() => {
                const date = getNextDayOfWeek(new Date(), 6);
                date.setDate(date.getDate() - 6);

                return date;
              })(),
            ],
            hints: {
              "greaterThanOrEqualTo.date_of_joining": "date",
              "lessThanOrEqualTo.date_of_joining": "date",
            },
          },
          before: {
            type: "DATE_PICKER",
            complete: true,
            filterKey: "lessThanOrEqualTo",
            hints: {
              "lessThanOrEqualTo.date_of_joining": "date",
            },
          },
          after: {
            type: "DATE_PICKER",
            complete: true,
            filterKey: "greaterThanOrEqualTo",
            hints: {
              "greaterThanOrEqualTo.date_of_joining": "date",
            },
          },
          Date_Range: {
            type: "DATE_RANGE_PICKER",
            complete: true,
            filterKey: ["greaterThanOrEqualTo", "lessThanOrEqualTo"],
            hints: {
              "greaterThanOrEqualTo.date_of_joining": "date",
              "lessThanOrEqualTo.date_of_joining": "date",
            },
          },
        },
      },
      is_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNotNull",
      },
      is_not_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNull",
      },
    },
  },
  date_of_birth: {
    type: "OPTION",
    options: {
      is: {
        type: "OPTION",
        options: {
          before: {
            type: "DATE_PICKER",
            complete: true,
            filterKey: "lessThanOrEqualTo",
            hints: {
              "lessThanOrEqualTo.date_of_birth": "date",
            },
          },
          after: {
            type: "DATE_PICKER",
            complete: true,
            filterKey: "greaterThanOrEqualTo",
            hints: {
              "greaterThanOrEqualTo.date_of_birth": "date",
            },
          },
          Date_Range: {
            type: "DATE_RANGE_PICKER",
            complete: true,
            filterKey: ["greaterThanOrEqualTo", "lessThanOrEqualTo"],
            hints: {
              "greaterThanOrEqualTo.date_of_birth": "date",
              "lessThanOrEqualTo.date_of_birth": "date",
            },
          },
        },
      },
      is_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNotNull",
      },
      is_not_set: {
        type: "VALUE",
        complete: true,
        filterKey: "isNull",
      },
    },
  },
  created_date: {
    type: "OPTION",
    options: {
      is: {
        type: "OPTION",
        options: {
          Today: {
            type: "VALUE",
            complete: true,
            filterKey: ["lessThanOrEqualTo", "greaterThanOrEqualTo"],
            value: [
              new Date().setHours(23, 59, 59),
              new Date().setHours(0, 0, 0),
            ],
            hints: {
              "greaterThanOrEqualTo.created_date": "datetime",
              "lessThanOrEqualTo.created_date": "datetime",
            },
          },
          Yesterday: {
            type: "VALUE",
            complete: true,
            filterKey: ["lessThanOrEqualTo", "greaterThanOrEqualTo"],
            value: [
              new Date(Date.now() - 24 * 60 * 60 * 1000).setHours(23, 59, 59),
              new Date(Date.now() - 24 * 60 * 60 * 1000).setHours(0, 0, 0),
            ],
            hints: {
              "greaterThanOrEqualTo.created_date": "datetime",
              "lessThanOrEqualTo.created_date": "datetime",
            },
          },
          This_week: {
            type: "VALUE",
            complete: true,
            filterKey: ["lessThanOrEqualTo", "greaterThanOrEqualTo"],
            value: [
              getNextDayOfWeek(new Date(), 6).setHours(23, 59, 59),
              (() => {
                const date = getNextDayOfWeek(new Date(), 6);
                date.setDate(date.getDate() - 6);

                return date.setHours(0, 0, 0);
              })(),
            ],
            hints: {
              "greaterThanOrEqualTo.created_date": "datetime",
              "lessThanOrEqualTo.created_date": "datetime",
            },
          },
          Date_range: {
            type: "DATE_RANGE_PICKER",
            complete: true,
            filterKey: ["greaterThanOrEqualTo", "lessThanOrEqualTo"],
            hints: {
              "greaterThanOrEqualTo.created_date": "datetime",
              "lessThanOrEqualTo.created_date": "datetime",
            },
          },
        },
      },
    },
  },
  cbool1: customBooleanFilterUnit,
  cbool2: customBooleanFilterUnit,
  cint1: customIntegerFilterUnit,
  cint2: customIntegerFilterUnit,
  cint3: customIntegerFilterUnit,
  cstring1: customStringFilterUnit,
  cstring2: customStringFilterUnit,
  cstring3: customStringFilterUnit,
};

export const validateFilterAndExtract = (filter): FilterInfo => {
  const falseResponse = {
    valid: false,
    filterField: null,
    filterValue: null,
    filterKey: null,
  };
  if (filter[0]) {
    let filterConfigUnit: FilterConfigUnit = filtersConfig[filter[0]];
    for (let i = 1; i <= 3; i++) {
      if (filterConfigUnit.type !== "VALUE" && !filter[i] && filter[i] !== 0) {
        return falseResponse;
      }
      const validResponse = {
        valid: true,
        filterField: filter[0],
        filterKey: filterConfigUnit.filterKey,
        filterValue: filter[i],
      };
      switch (filterConfigUnit.type) {
        case "OPTION":
          if (filterConfigUnit.options[filter[i]]) {
            filterConfigUnit = filterConfigUnit.options[filter[i]];
            break;
          }
          return falseResponse;

        case "VALUE":
          return { ...validResponse, filterValue: filterConfigUnit.value };

        case "MULTI_SELECT_DESIGNATION_TYPE":
        case "MULTI_SELECT_GENDER_TYPE":
        case "MULTI_SELECT_SHIFT_TYPE":
        case "MULTI_SELECT_TEAM_ROLE_TYPE":
          if (Array.isArray(filter[i]) && filter[i].length > 0) {
            return validResponse;
          }
          return falseResponse;

        case "STRING_INPUT":
          if (typeof filter[i] === "string" && filter[i].length > 0) {
            return validResponse;
          }

        case "INTEGER_INPUT":
          if (typeof filter[i] === "number") {
            return validResponse;
          }
          return falseResponse;

        case "DATE_RANGE_PICKER":
          if (Array.isArray(filter[i]) && filter[i].length === 2) {
            return validResponse;
          }
          return falseResponse;

        case "DATE_PICKER":
          if (filter[i]) {
            return validResponse;
          }

        default:
          return falseResponse;
      }
    }
  }
  return falseResponse;
};

export const filterSinglefieldFilter = (
  userValue: any,
  filterKey: FilterKeysType | Array<FilterKeysType>,
  filterValue: any
) => {
  if (Array.isArray(filterKey)) {
    return filterKey.every((key, index) =>
      filterSinglefieldFilter(userValue, key, filterValue[index])
    );
  }
  if (filterKey === "isNull") {
    return userValue === null || userValue === undefined;
  }
  if (filterKey === "isNotNull") {
    return userValue !== null && userValue !== undefined;
  }
  if (filterKey === "notContains") {
    return !filterValue.some((value) => value === userValue);
  }
  if (userValue === null || userValue === undefined) {
    return false;
  }
  if (filterKey === "equals") {
    return typeof userValue === "string" && typeof filterValue === "string"
      ? userValue.toLowerCase() === filterValue.toLowerCase()
      : userValue === filterValue;
  }
  if (filterKey === "ilike") {
    return (
      typeof userValue === "string" &&
      userValue.toLowerCase().includes(filterValue.toLowerCase())
    );
  }
  if (filterKey === "greaterThanOrEqualTo") {
    return typeof filterValue === "string"
      ? new Date(userValue).getTime() >= new Date(filterValue).getTime()
      : userValue >= filterValue;
  }
  if (filterKey === "lessThanOrEqualTo") {
    return typeof filterValue === "string"
      ? new Date(userValue).getTime() <= new Date(filterValue).getTime()
      : userValue <= filterValue;
  }
  if (filterKey === "contains") {
    return filterValue.includes(userValue);
  }

  return false;
};

export const filterUsers = (
  userData: Array<User>,
  teamData: { [key: string]: Group },
  filters: Array<Array<any>>
): Array<User> => {
  const validFiltersList = filters.reduce((acc, filter) => {
    const { valid, filterField, filterKey, filterValue } =
      validateFilterAndExtract(filter);
    if (valid && filterField && filterKey) {
      acc.push({ filterField, filterKey, filterValue });
    }
    return acc;
  }, [] as Array<ValidFilterInfo>);

  return userData.filter((user) => {
    const team = teamData?.[user.attached_group_id];
    user.user_type = isStealth(user.identity.email) ? "STEALTH" : "STANDARD";

    if (team) {
      user.shift = user.shift || team.shift;
      user.attached_group = team;
    }
    return validFiltersList.every(({ filterField, filterKey, filterValue }) => {
      let userValue = user[filterField];
      if (filterField.includes(".")) {
        userValue =
          user?.[filterField.split(".")[0]]?.[filterField.split(".")[1]];
      }

      return filterSinglefieldFilter(userValue, filterKey, filterValue);
    });
  });
};
